"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_VALUE_FROM_NODE = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.DELETE_VALUE_FROM_NODE = (0, gql_1.gql)(`
  mutation deleteValueFromNode($productLabelValidation: EditProductLabelValidationInput!, $sort: [ProductTreeNodeRelativeOrderBy!]!) {
    editProductLabelValidation(productLabelValidation: $productLabelValidation) {
      success
      error
      productTreeNode {
        ancestors(first: 100, sort: $sort) {
          edges {
            node {
              ancestor {
                id
              }
            }
          }
        }
      }
    }
  }
`);
